import { render, staticRenderFns } from "./KagamiSection.vue?vue&type=template&id=c4cf8c9a&scoped=true"
import script from "./KagamiSection.vue?vue&type=script&lang=js"
export * from "./KagamiSection.vue?vue&type=script&lang=js"
import style0 from "./KagamiSection.vue?vue&type=style&index=0&id=c4cf8c9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4cf8c9a",
  null
  
)

export default component.exports